import $ from '../../../../../src/Resources/core/jsx/utils/jquery-global';

import 'slick-carousel';
import 'lightbox2';
import '../enhanced_lightbox_fix';
import { applyHiddenStatusOfSelector } from '../lib/toggles';

$(document).ready(function () {
  applyHiddenStatusOfSelector('.timeline-experience');

  var toTop = $('.to-top');
  const searchField = $('#mh-timeline-search-field');

  toTop.on('click', function () {
    $('html, body').animate({
      scrollTop: $('html, body').offset().top,
    });
  });
  // Init first visible slide
  $('.carousel-item.active .inner-slider').not('.slick-initialized').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><i class='fas fa-chevron-left'></i></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><i class='fas fa-chevron-right'></i></button>",
  });

  // Re-init slick on visible slide after carousel change
  $('#carouselExampleControls').on('slid.bs.carousel', function () {
    var $activeItem = $(this).find('.carousel-item.active');
    if (!$activeItem.find('.inner-slider').hasClass('slick-initialized')) {
      $activeItem.find('.inner-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: true,
        prevArrow:
          "<button type='button' class='slick-prev pull-left'><i class='fas fa-chevron-left'></i></button>",
        nextArrow:
          "<button type='button' class='slick-next pull-right'><i class='fas fa-chevron-right'></i></button>",
      });
    }
  });

  $('#flexSwitchHistory').on('click', function () {
    console.log('filter historical event');
    $('.timeline-mh-historical-event').toggleClass(
      'timeline-experience-history-hidden',
    );
    applyHiddenStatusOfSelector('.timeline-mh-historical-event');
  });

  $('.timeline-sidebar-all-filter').on('click', function () {
    var checked =
      document.getElementById('timeline-sidebar-filter-all-cb').checked;
    console.log('checked: ' + checked);
    $('.timeline-sidebar-filter-cb').each(function () {
      //$(this).checked = !checked;
      //$(this).click();
      var lh_checked = this.checked;
      if (checked != lh_checked) {
        $(this).click();
      }
    });

    applyHiddenStatusOfSelector('.timeline-experience');
  });

  $('#timeline-experience-lht-karmapas').on('click', function () {
    toggle_teacher_class('karmapas');
  });

  $('#timeline-experience-lht-shamarpas').on('click', function () {
    toggle_teacher_class('shamarpas');
  });

  $('#timeline-experience-lht-mahasiddhas').on('click', function () {
    toggle_teacher_class('mahasiddhas');
  });

  $('#timeline-experience-lht-others').on('click', function () {
    toggle_teacher_class('others');
  });
});

function toggle_teacher_class(teacherName) {
  const className = `.timeline-experience-lht-${teacherName}`;
  $(className).toggleClass('timeline-experience-lht-hidden');
  applyHiddenStatusOfSelector(className);
}
